const language = {
	locale: 'es',
	yes: 'Si',
	not: 'No',
	report_title: 'Reportes',
	number: 'Número',
	month_select: 'Selecciones el mes',
	monthly: 'Mensual',
	month: 'mes',
	year: 'año',
	outted: 'Salida',
	inner: 'Entrada',
	add_new_number: 'Agregar nuevo número',
	edit_number_meta: 'Cambiar número',
	amount_of_actived_numbers:
		'Números {avaliableToActive, plural, one {disponible} other {disponibles}} {actived}/{avaliableToActive}',
	amount_of_numbers_new_plan:
		'Números utilizados: PRO {active_pro}/{total_pro} BASIC: {active_basic}/{total_basic}',
	actives: 'Activos',
	inactives: 'Inactivos',
	inactive: 'Inativo',
	numbers_title: 'Lista de números',
	just_left: 'Próximo pago en',
	subscription_title: 'Suscripción',
	renew: 'Renovar',
	renew_now: 'Renovar ahora',
	day: '<b>{day, plural, one {# dia} other {# dias}}</b>',
	connected_channels_title: 'Canales conectados',
	terms_of_use_title: 'Terminos de uso',
	terms_of_use_conditions: 'Condiciones de processamiento de datos personales',
	terms_of_use_secure: 'Politica de privacidad',
	update_list_title: 'Atualizaciones',
	last_update_title: 'Actualizaciones Recientes',
	last_update_system_version: 'Versión actual del sistema',
	see_more: 'Ver más',
	last_update_your_version: 'Su versión actual',
	edit: 'Editar',
	unlink_channel: 'Desvincular Canal',
	link_channel: 'Vincular Canal',
	delete: 'Apagar',
	clear_queue: 'Borrar cola',
	add_numbers_title: 'Añadir nuevo numero',
	edit_numbers_title: 'Editando número: {number}',
	numbers_form_nickname: 'Apodo',
	total_campaign: 'Mensajes en cola',
	update_campaign: 'Actualizar',
	cancel_campaign: 'Limpiar cola',
	form_msg_nickname: 'OPS, Usted no eligió un apodo',
	numbers_form_api: 'Seleccionar la API',
	form_msg_api: 'OPS, Usted no seleccionó la API',
	numbers_form_token: 'TOKEN del Integrador',
	form_msg_token: 'OPS, Usted no puso el token de la API',
	numbers_form_account: 'ID de la Instancia/ID de la Conta',
	form_msg_account: 'OPS, Usted no puso la ID de la Instancia o la ID de la Conta',
	numbers_form_namespace: 'Namespace del canal',
	form_msg_namespace: 'OPS, Usted no puso el namespace del canal',
	numbers_form_country: 'País de origen',
	form_country: 'País de origen',
	steps_form_country: 'País de origen',
	form_msg_country: 'OPS, Usted debe poner el pais de origen',
	form_is_national: 'Origen de los contactos',
	form_msg_is_national:
		'OPS, Usted debes selecionar si tienes solamiente contactos nacionales o tambíen internacionales.',
	numbers_form_phone_number: 'Número de Telefono',
	form_msg_phone_number: 'OPS, Pongas el número del Telefono',
	form_msg_channel_id: 'OPS, Pongas el Channel ID',
	steps_form_channel: 'Canales',
	steps_form_phone_number: 'OPS, Pongas el número del Telefono',
	steps_form_namespace: 'Namespace del canal',
	form_status: 'Estado del dispositivo',
	form_msg_status: 'OPS, Usted se olvidó de selecionar el estado de su dispositivo',
	link_channel_title: 'Vincular canal',
	link_form_channel: 'Selecciones el Canal',
	link_channel_success: 'Canal vinculado con éxíto!',
	link_channel_error: 'Error al vincular el canal',
	unlink_channel_success: 'Canal desvinculado con éxito!',
	unlink_channel_error: 'Error al desvincular el canal',
	unlink_channel_msg: 'Estas seguro que deseas desvincular este canal ',
	clear_queue_msg:
		'¿Estás seguro de que quieres borrar la cola? Esto cancelará todos los mensajes que se enviaron desde Bitrix24 mientras el número estaba desconectado.',
	number_of_messages_on_queue: 'Número de mensajes en cola: ',
	delete_msg: 'Estas seguro que deseas eliminar ',
	placeholder_search_address: 'Buscar dirección',
	loading_map: 'Cargando mapa...',
	map_load_error: 'No fue posible cargar el mapa.',

	// Marketing Campaign
	status_tooltip:
		'El estado del mensaje de WhatsApp (entregado y leído) depende de la configuración de privacidad del contacto.',
	write_your_campaign_message: 'Escriba su mensaje de campaña',
	write_your_message_here: 'Escriba su mensaje aquí',
	upload_file_max_size: 'El tamaño máximo de archivo permitido por Meta es 100MB',
	select_variable: 'Seleccione una variable',
	new_campaign: 'Nueva Campaña',
	search: 'Buscar',
	send_manually: 'Enviar manualmente',
	campaign_name: 'Nombre de la Campaña',
	scheduled_for: 'Programado para',
	reschedule: 'Reprogramar',
	campaign_reschedule: 'Reprogramar la entrega de la campaña',
	reschedule_message_success: '¡Campaña reprogramada con éxito!',
	reschedule_message_error: 'Error al reprogramar la campaña.',
	remaining_time: 'Tiempo restante',
	sent: 'Enviado',
	delivered: 'Entregado',
	read: 'Leído',
	failed: 'Falló',
	error: 'Error',
	status_pending: 'Pendiente',
	start_sending_now: 'Comenzar a enviar ahora',
	view_campaign_items: 'Ver detalles',
	destination_number: 'Número de destino',
	message_status: 'Estado del mensaje',
	message_success: 'Mensaje enviado con éxito.',
	description_status: 'Descripción',

	delete_campaign_confirmation:
		'¿Estás seguro de que deseas eliminar esta campaña? Esta acción no se puede deshacer y cancelará inmediatamente la ejecución de la campaña.',
	of: 'de',
	finished: 'Completado',
	awaiting_start: 'Esperando para comenzar',
	queued: 'En cola',
	estimating: 'Estimando',
	less_than_a_minute: 'Menos de un minuto',
	hour: 'hora',
	minute: 'minuto',
	and: 'y',
	set_campaign_name: 'Define el nombre de la campaña',
	campaign_name_placeholder: 'Nombre de la campaña',
	deal: 'Negocio',
	contact: 'Contacto',
	lead: 'Lead',
	company: 'Empresa',
	field_required: 'Campo obligatorio',
	configure_segment: 'Configura el segmento al que deseas enviar la campaña',
	define_campaign_segment: 'Define el segmento de la campaña',
	segment_name: 'Nombre del segmento',
	conditionals: 'Condicionales',
	bigger_than: 'Mayor que',
	smaller_than: 'Menor que',
	equal_to: 'Igual a',
	different_from: 'Diferente de',
	bigger_or_equal_to: 'Mayor o igual a',
	smaller_or_equal_to: 'Menor o igual a',
	contains: 'Contiene',
	add_field: 'Agregar campo',
	required_campaign_name: 'El nombre de la campaña es obligatorio',
	required_source_number: 'El número de origen es obligatorio',
	required_audience: 'La audiencia es obligatoria',
	required_segment: 'El segmento es obligatorio',
	required_message: 'El mensaje es obligatorio',
	required_template: 'La plantilla es obligatoria',
	required_parameters: 'Los parámetros son obligatorios',
	required_send_when: 'Cuando enviar es obligatorio',
	required_send_date: 'La fecha de envío es obligatoria',
	name: 'Nombre',
	audience: 'Audiencia',
	message: 'Mensaje',
	finish: 'Finalizar',
	saving: 'Guardando',
	save: 'Guardar',
	all_contacts: 'Todos los contactos',
	all_companies: 'Todas las empresas',
	all_leads: 'Todos los leads',
	all_deals: 'Todos los negocios',
	all_base: 'Toda la base',
	deals: 'Negocios',
	contacts: 'Contactos',
	companies: 'Empresas',
	define_campaign_audience: 'Define la audiencia de la campaña',
	source_number: 'Número de origen',
	select_source_number: 'Selecciona el número de origen',
	select_audience_type: 'Selecciona el tipo de audiencia',
	static_list: 'Lista estática',
	dynamic_list: 'Lista dinámica',
	custom_recipients:
		'Lista de destinatarios personalizados, separados por coma o por salto de línea. Ej: 5511999999999, 5511999999999 o \n5511999999999\n5511999999999',
	select_segments: 'Selecciona los segmentos',
	segment_filters: 'Filtros de segmento',
	select_campaign_template: 'Selecciona la plantilla de la campaña',
	choose_variables: 'Elige entre las variables disponibles o escribe el valor manualmente',
	campaign_ready_1: 'La campaña',
	campaign_ready_2: '¡está lista para ser enviada!',
	campaign_worktime_title: 'Enviar campañas solo durante el horario comercial',
	campaign_worktime_tooltip:
		'Los envíos realizados fuera del horario comercial se reprogramarán automáticamente.',
	when_to_send: '¿Cuándo deseas enviar?',
	now: 'Ahora',
	later_manually: 'Después, manualmente',
	schedule: 'Programar',
	saving_campaign: 'Guardando campaña...',
	campaign_ready_title: '¡Tu campaña está lista!',

	delete_campaign_warning:
		'Hay una campaña en marcha para este número; eliminarla también lo eliminará.',
	clear_campaign_queue: '¿Está seguro de que desea borrar la cola de la campaña ',
	clear_campaign_queue_success: '¡La cola de campaña se eliminó correctamente!',
	clear_campaign_queue_error: '¡OPS! No fue posible eliminar la cola de campaña para este número.',
	create_campaigns: '¡Aprenda a crear campañas de marketing en Bitrix24 usando PowerZap! {link}',
	send_only_during_work_hours: 'Enviar solo durante el horario de trabajo',
	confirm_notification_noLinkedChannel:
		'El número configurado no está vinculado a ningún canal abierto. En este caso, no hay horario de atención a considerar y los mensajes se enviarán en cualquier momento.',
	confirm_notification_worktimeDisabled:
		'El canal abierto al que está conectado el número no tiene horario de atención definido. En este caso, la opción se desestimará y los mensajes se enviarán en cualquier momento.',

	work_hours_defined_in_bitrix24_channel:
		'Horario de trabajo definido en el canal abierto de Bitrix24, del número en cuestión.',
	click_here_to_configure: 'Haz clic aquí para configurar.',
	clear_queue_immediately: 'Limpiar cola inmediatamente',
	settings: 'Configuraciones',

	last_update_version: 'Reporte de actualización - Versión {version}',
	api: 'API',
	actions: 'Acciones',
	clear_queue_success: '¡Cola despejada!',
	clear_queue_error: 'Error al borrar la cola',
	delete_number_success: 'Número eliminado con éxito!',
	delete_number_error: 'OPS! No foe posible eliminar su número',
	not_found_registers: 'No se encontraron registros!',
	alert_audio:
		'ATENCIÓN: Solo es posible enviar audio o un adjunto a conversaciones que ya se han iniciado. ¡Enviar audio o un archivo adjunto a una nueva conversación puede causar que el número sea bloqueado!',
	toggle_mbird: '¿Quieres enviar audio o un archivo adjunto a un número con conversación activa?',
	new: 'Nuevo',
	online: 'En linea',
	offline: 'Desconectado',
	channel_name: 'Nombre del canal abierto',
	edit_number_success: 'Número editado con éxito!',
	add_number_success: 'Número agregado con éxito!',
	tutorials_title: 'Tutoriales',
	all_numbers: 'Todos los números',
	step_one: 'Bienvenidas',
	step_two: 'Integrador',
	step_three: 'Configurando',
	step_four: 'Dispositivo',
	step_five: 'Listo',
	step_six: 'Webhook',
	step_seven: 'Canal Abierto',
	step_whatsapp: 'Tu WhatsApp',
	step_first_message: 'Primer Mensaje',
	to_start:
		'Ahora que descargastes nuestro conector, selecciones un de los integradores disponíbles',
	what_is_integrator:
		'OBS: Integrador es la plataforma que ira hacer o servicio de envio de las mensages',
	with_base: 'En base a la imagem al lado',
	type_token: 'Inserte el Token',
	type_device_id: 'Inserte el ID del Dispositivo/ID de la Cuenta',
	type_namespace: 'Inserte el Namespace del Canal',
	steps_form_account: 'ID del Dispositivo o de la cuenta',
	select_country: 'Cual es su pais de origen?',
	type_number: 'Cual número de telefono usaras para enviar mensages.',
	agree0: 'Envía mensajes',
	agree_desc0: 'Envía mensajes a tus leads y clientes directamente desde las entidades del CRM.',
	agree1: 'Recibe mensajes',
	agree_desc1:
		'Conecta WhatsApp a los canales abiertos y accede a todas las funcionalidades nativas.',
	agree2: 'Distribuye contactos',
	agree_desc2:
		'Con un único número de WhatsApp, distribuye las conversaciones entre todo tu equipo.',
	agree3: 'Automatiza la atención',
	agree_desc3: 'Configura reglas ilimitadas para enviar mensajes automáticos, sin esfuerzo manual.',
	all_done: 'Felicitaciones! Viste como foe fácil!',
	done: 'Ir para el APP',
	previous: 'Anterior',
	next: 'Siguiete',
	skip: 'Saltar',
	confirm_skip: '¿Realmente quieres saltarte el tutorial de configuración?',
	billing_point1: 'Integración con canales abiertos',
	billing_point2: 'Envio de mensage por el CRM',
	billing_point3: 'Regla de automacion exclusiva',
	billing_point4: 'Elijas dentre esas APIs',
	billing_point5: 'Suporte ilimitado',
	billing_point6: 'Hasta 20.000 mensages enviadas y recebidas por mes',
	free_test: 'Prueba gratis',
	from_price: 'desde',
	discount: 'de descuento',
	annualy: 'anual',
	add_subscription_error: 'Hubo un error al activar el trial.',
	add_number_error: 'No se puede guardar el número, verifique los datos ingresados.',
	actual_month: 'Este Mes',
	last_month: 'Mes pasado',
	subscription_expired_msg: 'Su Suscripción ha expirado, revisa la area de suscripciones.',
	national: 'Nacional',
	not_national: 'Nacional/Internacional',
	not_done_yet: 'Estamos casi listos! Queda solamiente un paso.',
	not_done_yet2: 'Usted necesita configurar el webhook ahora!',
	not_done_yet3: 'Siga este tutorial:',
	not_done_yet4: 'Este número vinculando estara con el canal: ',
	subscription_expired: 'Su Suscripción ha expirado, intentes renovar ahora!.',
	try_send: 'Para probar su aplicación, intentes enviar una mensage abajo',
	test_message_prefill: '¡Hola! Este es un mensaje de prueba directo desde PowerZap.',
	select_destination: 'Selecciones el número de destino',
	type_your_msg: 'Inserta su mensage',
	send_msg: 'Enviar',
	files_text1_mobile: 'Haga click aquí para hacer el upload',
	files_text1: 'Haga click aquí o arrastres el archibo para esta area para hacer el upload',
	files_text2: 'Soporte para un upload único',
	file_type: 'Solamiente archibos jpg, png, pdf son suportados',
	send_message_success: 'Mensage enviada',
	send_message_error: 'Error al enviar mensage',
	send_message_unexpected_error:
		'Ha ocurrido un error inesperado al enviar el mensaje, comuníquese con nuestro equipo de soporte',
	url_signature_expired:
		'URL de medios ha expirado. Actualice la URL en configuración del template.',
	empty_parameters: 'Complete todos los parámetros de la plantilla.',
	location_required: 'Complete el campo de ubicación del template.',
	back: 'Regresar',
	current: 'Actual',
	select: 'Seleccionar',
	hello: 'Olá {name} :)',
	have_update: 'Seu aplicativo possui atualizações.',
	have_update_button: 'Actualizar ahora!',
	updated_successfull: 'Updated sucessfully',
	updated_error: 'Update error',
	welcome_title: '¡Qué bueno tenerte aquí!',
	welcome_subtitle: '¿Conectamos tu WhatsApp?',
	welcome: 'Felicitaciones!',
	welcome2: 'Usted recien he instalado el mejor conector de Whatsapp del Bitrix24',
	welcome3: 'y estas a pocos pasos de mejorar su atendimiento con el Whatsapp.',
	example_number:
		'Ejemplo: 554499999999, 55 es el código del pais, 44 es el codigo de la provincia, el restante es el numero del telefono',
	oficial: 'API Oficial',
	not_oficial: 'API No Oficial',
	oficial_twilio:
		'IMPORTANTE: \n Twilio es un integrador oficial de la API de Whatsapp, \n con esto necesitas solicitar la aprobación del número con Facebook (propietario de Whatsapp). \n Este período de aprobación toma un promedio de 30 días. \n Si no desea esperar este período, contrate otro integrador y use la aplicación de inmediato. \n Simplemente vuelva al paso anterior y seleccione el integrador que mejor se adapte a sus necesidades. ',
	zapbox_desc:
		"Para configurar tu número es necesario que ya tengas contratado un plan y activado tu cuenta Zapbox. Si aún no lo ha hecho, acceda al panel de Zapbox y active su número <a target='_blank' href='https://whatsweb.app/account/login'> (Haga clic aquí para acceder)</a>",
	twilio_desc:
		'IMPORTANTE: \n Twilio es un integrador oficial de la API de Whatsapp, \n con esto necesitas solicitar la aprobación del número con Facebook (propietario de Whatsapp). \n Este período de aprobación toma un promedio de 30 días. \n Si no desea esperar este período, contrate otro integrador y use la aplicación de inmediato. \n Simplemente vuelva al paso anterior y seleccione el integrador que mejor se adapte a sus necesidades. ',
	not_oficial_desc:
		'Integradores no oficiales. Nuestro conector no tiene vínculo con los integradores. Para obtener más información, acceda a las Políticas de privacidad y Condiciones de uso.',
	open_channel:
		"Los canales abiertos de Bitrix24 recopilan mensajes de todos los canales de comunicación con los clientes y los distribuyen entre los agentes de la fila. <br> <br>Para obtener más información sobre los canales abiertos <a target='_blank' href='https://helpdesk.bitrix24.com.br/open/9612023/'> (Haga clic aquí para acceder)</a>",
	time_left: 'Quedan {days, plural, one {# dia} other {# dias}} para expirar su tiempo de prueba',
	subscription_error_warning:
		'Parece que hay un error con su suscripción, consulte su administrador',
	cancel: 'Cancelar',
	subscription_limit_msg: 'Has excedido el limite de números permitidos por su plan.',
	msg_empty: '´El Cuerpo de la mensage no puede estar vacío.',
	to_empty: 'El destino no puede estar vacío.',
	params_empty: 'Las cajas de texto no pueden estar vacías',
	from_empty: 'La origen no puede estar vacía.',
	sending_message: 'Enviando mensaje...',
	promotion_title: ' Incremente los resultados de su empresa con WhatsApp y Chat Booster',
	promotion_text1: ' Incremento del ROI',
	promotion_text2: ' Priorización de asistencia',
	promotion_text3: ' Generación de Oportunidades 24h',
	promotion_text4: ' Automatización de respuestas para cada perfil de cliente',
	promotion_text5: ' Calificación de Leads',
	promotion_text6: ' Beneficios de principio a fin, desde el marketing hasta el posventa',
	try_now: 'Prueba gratis Ahora!',
	dont_show_again: 'No volver a mostrar',
	close: 'Cerrar',
	number_empty: 'El Número esta vacío!',
	token_empty: 'El Token esta vacío!',
	device_id_empty: 'ID del dispositivo esta vacío!',
	namespace_empty: 'Namespace esta vacío!',
	api_empty: 'Elige una api!',
	under_maintenance: 'Módulo de Reportes foe discapacitado por un momiento para actualización',
	know_you_better: 'Queremos conocerte mejor!',
	prioritize_your_resources: 'Asi, poderemos dar prioridad a recursos essenciales a usted!',
	full_name: 'Nombre completo',
	enterprise_website: 'Sitio web de la empresa',
	email: 'Correo eletronico',
	enterprise_phone: 'Telefono/WhatsApp',
	country: 'País',
	send: 'Enviar',
	lead_capture_title: 'Antes de comenzar, ¡queremos conocerte mejor!',
	lead_capture_subtitle:
		'Tus respuestas nos ayudan a mostrar primero los recursos que tienen sentido para tu negocio.',
	lead_capture_email_placeholder: 'Escribe tu correo electrónico',
	lead_capture_website_label: 'Sitio web de la empresa',
	lead_capture_website_placeholder: 'Escribe tu sitio web',
	lead_capture_objective_label: 'Objetivo principal con PowerZap',
	select_country_placeholder: 'Selecciona',
	start_configuration: 'Iniciar configuración',
	support: 'Hablar con soporte',
	lead_status: 'Status',
	deal_category: 'Embudo',
	deal_stage: 'Fase',
	from_number: 'Número de origen',
	to_numbers: 'Números de destino',
	to_number: 'Número de destino',
	log_messages: 'Historial de mensages',
	date: 'Fecha',
	message_count: 'Total de mensages enviadas y recebidas en el mes',
	message_in: 'Recebidas',
	message_out: 'Enviadas',
	message_total: 'Total de mensajes este mes',
	warning_message_count:
		'Ahora podes mirar la cantidad de mensajes enviadas y recebidas en el mes!',
	warning_amount_numbers: 'Ahora no necesitas preocuparse con la cantidad de números disponibles!',
	custom_made_plan_title: 'Personalize su plan',
	custom_made_plan_body:
		'Envie + de 20.000 mensages/mes en un plan hecho en la medida para su empresa',
	custom_made_plan_button: 'Solicitar presupuesto',
	record_audio_tooltip: 'Grabar Áudio',
	play_audio_tooltip: 'Reproducir áudio',
	discard_audio_tooltip: 'Eliminar áudio',
	attach_audio_tooltip: 'Agregar áudio',
	recording_audio: 'Grabando...',
	reports_leads_title: 'LEADS WHATSAPP',
	reports_leads_title_warning: 'Recuerde que este reporte hace referencia al período seleccionado!',
	reports_deals_title: 'NEGÓCIOS WHATSAPP',
	reports_deals_title_warning:
		'RRecuerde que este reporte hace referencia al período seleccionado!',
	data_picker: 'Periodo de los reportes',
	percent_leads: 'Porcentaje de Leads',
	percent_warning: 'Generados por el Whatsapp en relacion al total, en el período seleccionado.',
	percent_deals: 'Porcentaje de Negócios',
	chart_ticket: 'Gaños mensuales de Negócios generados por el Whatsapp',
	reports_ticket_title_warning:
		'Recuerde que este reporte hace referencia lo período seleccionado!',
	deals_op_warning: 'Recuerde que este reporte hace referencia al período seleccionado!',
	deals_op: 'Valor total de los negócios generados por el Whatsapp',
	marketing_campaigns_tab_title: 'CAMPAÑAS DE MARKETING',
	billing_central_tab_title: 'CENTRO DE PAGO',
	help_tab_title: 'AYUDA',
	permissions_tab_title: 'PERMISOS',
	dashboard_tab_title: 'PANEL DE CONTROLE',
	reports_tab1: 'REPORTES',
	data_picker_gerar: 'Generar reportes',
	message_count_warning_title: 'Aviso!',
	message_count_warning_message: 'Informe de datos no disponibles temporalmente!',
	image_banner: 'banner_esignature_en.jfif',
	try_now_month: 'Quiero el Plan Mensual!',
	try_now_year: 'Quiero el Plan Anual!',
	choose_an_integrator: 'Elija un integrador para continuar',
	warning_maximum_file_size: 'El archivo tiene más de 100 MB.',
	view_header_document: '📄 Ver documento',
	warning_header_image: 'Por favor, cargue una imagen para continuar.',
	leads: 'Leads',
	won: 'Ganados',
	in_progress: 'En Curso',
	lost: 'Perdidos',
	converted: 'Convertidos',
	monthly_profit: 'Ingressos Mensuales',
	month_0: 'Enero',
	month_1: 'Febrero',
	month_2: 'Marzo',
	month_3: 'Abril',
	month_4: 'Mayo',
	month_5: 'Junio',
	month_6: 'Julio',
	month_7: 'Agosto',
	month_8: 'Septiembre',
	month_9: 'Octubre',
	month_10: 'Novembre',
	month_11: 'Decembre',
	open_channels: 'Canales abiertos',
	open_channels_text: 'Los datos presentados se refieren a los siguientes canales abiertos:',
	open_channels_tooltop:
		'Para mostrar datos de otro canal abierto de WhatsApp, vincule el canal abierto a algún número en la pestaña PANEL DE CONTROL',
	open_channels_empty: '¡Vincula un canal abierto a WhatsApp para recibir datos de reportes!',

	// SubscriptionView
	my_subscription: 'Gestionar mi suscripción',
	subscription_now: 'Activar suscripción ahora',
	update_payment: 'Actualizar tarjeta de crédito',
	renew_failed: '<b>No se pudo renovar su suscripción.</b>',
	trial_expired:
		'<strong>Su período de prueba ha terminado.</strong> {br} Activa tu suscripción para seguir usando la aplicación.',
	trial_left: 'Su período de prueba gratuito terminará en',
	trial_final_1: '¡Tu período de prueba está terminando! Solo quedan ',
	trial_final_2: '. Elija su plan de suscripción o <a>haga clic aquí</a> para obtener ayuda.',
	on_hold_message: 'Actualiza los datos de tu tarjeta de crédito para seguir usando la aplicación.',
	active_left: 'Su suscripción se renovará automáticamente en',
	alert_title: 'Error de Autenticación',
	alert_message:
		'Para que el proceso de autenticación se lleve a cabo correctamente, un usuario con permisos de administrador debe acceder a la aplicación.',
	template: 'Seleccione una plantilla',
	template_title: 'Plantilla (deshabilitada en caso de audio o archivo)',
	template_error: 'Error al obtener el template',
	template_fetch_permission_error:
		'Es posible que se hayan eliminado o expirado los permisos de acceso a su Cuenta Comercial de WhatsApp. Verifique que su cuenta aún tenga acceso con el socio y que el token de acceso sea válido.',
	unknown_error: 'Error desconocido',
	possible_cause: 'Posible causa',
	template_error_envio:
		'Se produjo un error al enviar la plantilla a uno o más números de la lista. Verifique la plantilla utilizada y los números de destino ingresados.',
	template_edited:
		'No fue posible enviar la plantilla. Fue editada recientemente y aún está pendiente de aprobación por parte de Meta. Recomendamos crear una nueva plantilla para agilizar el proceso de verificación.',
	healthy_ecosystem:
		'Este mensaje no se entregó para mantener un ecosistema de participación saludable.',
	invalid_tokens:
		'El token del canal parece no ser válido. Esto suele ocurrir cuando el número fue registrado en otra plataforma. Intente volver a agregar el número o contacte al soporte.',
	using_test_tokens: 'Utilice tokens "live" en lugar de tokens "test".',
	legacy: 'Plano Legacy',
	basic: 'Plano Basic',
	pro: 'Plano Pro',
	total_recurring: 'Total recurrente',
	renew_in: 'Renovación en',
	pro_numbers: 'Números PRO',
	basic_numbers: 'Números BASIC',
	subscription_not_found:
		'<b>Suscripción no encontrada.</b> {br} Activa tu suscripción para seguir usando la aplicación.',
	upgrade_subscription: 'Actualizar suscripción ahora',
	upgrade_subscription_text: 'Actualice su suscripción para usar PowerZap.',

	// Help MessageBird
	help_MessageBird_title: 'MessageBird (API oficial)',
	help_MessageBird_1:
		'To configure our connector next to MessageBird it is interesting to start with the MessageBird screen.',
	help_MessageBird_2: 'Log in to your account and select the tab <b>Developers</b>',
	help_MessageBird_3: 'next, <b>API Acess</b> and select the <b>Add acess Key</b>',
	help_MessageBird_4: 'Name your connection and select <b>Live</b>',
	help_MessageBird_5: 'Select <b>Show key</b>',
	help_MessageBird_6: 'Copy <b>Key</b>',
	help_MessageBird_7: 'In our APP, add a device',
	help_MessageBird_8: 'Name and choose the <b>MessageBird</b>',
	help_MessageBird_9: 'Add the token in the field provided',
	help_MessageBird_10: 'Go back to MessageBird selecione and select the tab <b>Chanels</b>',
	help_MessageBird_11:
		"Choose the WhatsApp channel and if you don't have the channel, just create a new WhatsApp channel",
	help_MessageBird_12:
		'Do the <b>scan off the QR code</b> with an WhatsApp APP or send the shown message for the indicated number',
	help_MessageBird_13: 'Copy the Channel ID',
	help_MessageBird_14: 'Paste in API Whatsapp.',
	help_MessageBird_15:
		"In Messagebird's <b>Channels</b> tab go to Whatsapp, <b>My Channels</b> and copy the <b>Template Namespace</b> from the chosen channel",
	help_MessageBird_16: 'Paste the info in the highlighted field',
	help_MessageBird_17: 'Go back to MessageBird select edit',
	help_MessageBird_18:
		'Copy your device number and paste in Mobile Number inside the API Whatsapp (the integrator number has to be equal to the integrator).',
	help_MessageBird_19: 'Save and done!',
	help_MessageBird_20: 'Your app is set up.',
	help_MessageBird_21: 'Now just link it to an open channel.',

	// Automatización de la ayuda
	help_automation_title: 'Automatizaciones',
	help_automation_1:
		'Para usar automatizaciones en PowerZap, ingrese al menú de automatizaciones en el embudo en el que desea agregar la regla de automatización y seleccione el <b>icono</b> que se muestra a continuación:',
	help_automation_2:
		'Seleccione la opción "Crear" en la pestaña Disparadores y reglas de automatización.',
	help_automation_3:
		'Seleccione la opción "Otro" y haga clic en "Agregar" en el elemento <b>[PowerZap WhatsApp API] Actividad de WhatsApp</b>.',
	help_automation_4:
		'Pon tu número de dispositivo. <b>Observación: El número ingresado debe ser el mismo registrado en PowerZap</b>',
	help_automation_5:
		'Seleccione el campo móvil de destino que pertenece al cliente potencial/negocio.',
	help_automation_6: 'Pon un mensaje.',
	help_automation_7:
		'Seleccione, opcionalmente, un archivo para enviar junto con el mensaje de automatización. Para esto, es necesario crear un campo de tipo de archivo en la tarjeta de prospecto/negocio y agregar un archivo (imagen, video, documento) a este campo.',
	help_automation_8:
		'Opcionalmente, complete este campo con un enlace a un archivo que se encuentra en su Bitrix24.Drive, para ser enviado junto con el mensaje de automatización.',
	help_automation_9:
		'Para esto, es necesario cargar un archivo(imagen, video, documento) a su Bitrix24.Drive, seleccione este archivo y haga clic en la opción "Compartir" y luego en la opción "Copiar enlace interno".',
	help_automation_10: 'Luego simplemente pegue el enlace copiado en el campo que se muestra.',
	help_automation_11:
		'Seleccione el usuario en Bitrix24 que se usará para ejecutar las automatizaciones.',
	help_automation_12: '¡Guardar y listo!',
	help_automation_13: '<b>ENVIANDO PLANTILLAS CON LA API OFICIAL</b>',
	help_automation_14:
		'Para enviar plantillas utilizando la API Oficial, utilice la siguiente sintaxis:',
	help_automation_15: '#template:NOMBRE_DE_TU_PLANTILLA',
	help_automation_16: '#parametros:PARÁMETRO1,PARÁMETRO2,PARÁMETRO3',
	help_automation_17: 'Como el siguiente ejemplo:',
	help_automation_18:
		'El mensaje resultante será la plantilla que elegiste, con los parámetros definidos en la automatización:',
	help_automation_19:
		'Otra opción es agregar el "ID de archivo" a este campo, para esto es necesario crear la automatización en modo "Flow Creator" y agregar los componentes "Drive Object Information" y "PowerZap WhatsApp API".',
	help_automation_20:
		'Luego, simplemente haga clic en los tres puntos al lado del campo "Bitrix24.Drive file ID/Link" y seleccione la opción "Resultados adicionales". Esta pantalla mostrará el elemento "Información del objeto de conducción", debe hacer clic en el elemento y elegir el atributo "ID".',
	help_automation_21:
		'De esta forma, el campo se completará con el ID del archivo seleccionado en el componente "Información del objeto Drive".',
	help_automation_22: '<b>Cómo enviar plantillas con ubicación mediante automatización</b>',
	help_automation_23:
		'Para enviar una plantilla con ubicación mediante la automatización, siga los pasos a continuación:',
	help_automation_24:
		'1. Abra Google Maps, busque la dirección deseada y copie el enlace completo que aparece en la barra de direcciones del navegador.',
	help_automation_25:
		'2. En la automatización, pegue este enlace justo después de la sintaxis #location: en el campo del mensaje.',
	help_automation_26:
		'3. La plantilla se enviará automáticamente con la ubicación correcta al usuario.',

	// Help Good Habits
	help_good_habits: 'Buenas prácticas de uso',
	good_habits: 'Buenas prácticas para utilizar PowerZap',
	good_habits_description:
		'Algunas buenas prácticas en la vida cotidiana pueden ser esenciales para evitar bloquear/ prohibir un número. Acciones simples que pueden marcar una gran diferencia. { link }',
	know_more: 'Sepa mas.',
	alert_good_habits:
		'Aprenda buenas prácticas para usar PowerZap para evitar bloquear/prohibir su número. {link}',
	help_good_habits_title: '<b> Buenas prácticas de uso </b>',
	help_good_habits_intro:
		'Algunas buenas prácticas en la vida cotidiana pueden ser esenciales para evitar bloquear/prohibir un número. Acciones simples que pueden marcar una gran diferencia.',
	help_good_habits_1:
		'1. Ten tu perfil de WhatsApp Business completo (con foto de perfil, dirección, descripción, sitio web, correo electrónico de contacto, etc.).',
	help_good_habits_2: '2. Evite enviar mensajes a números que no estén en sus contactos.',
	help_good_habits_3:
		'3. Personalice mensajes con información del destinatario. Si esto no es posible, utilice atributos aleatorios para diferenciar cada mensaje.',
	help_good_habits_4:
		'4. Anime al destinatario a interactuar con su número, especialmente si sabe que no tiene su número en su directorio telefónico.',
	help_good_habits_5: '5. Ofrezca al destinatario la opción de dejar de recibir mensajes.',
	help_good_habits_6: '6. Envíe mensajes SÓLO a clientes que tengan recepción autorizada.',
	help_good_habits_7: '7. Evite el contenido de los mensajes con lenguaje inapropiado.',
	help_good_habits_8: '8. Evite enviar mensajes automáticos con enlaces e imágenes.',
	help_good_habits_9:
		'9. Utilice las automatizaciones de Bitrix24 con precaución para cargas controladas y moderadas.',
	help_good_habits_10:
		'10. Para recibir mensajes con promociones, recomiende al destinatario agregar el número de la empresa a sus contactos y enviar un mensaje diciendo "Quiero promociones". Esta acción reduce significativamente el riesgo de bloqueos, ya que, con el número en la agenda e iniciando la conversación, no aparecen los botones de bloqueo y reporte de spam.',
	help_good_habits_11:
		'mensajes con los datos del destinatario (por ejemplo, Nombre, Apellido, Apellido, etc.) para evitar que todos los mensajes sean exactamente iguales.',
	help_good_habits_12:
		'12. Proporcione siempre una opción para que el destinatario deje de recibir mensajes. Por ejemplo: "Ingrese 2 para no recibir más estos mensajes". Esto le permite eliminar de sus listas de envío los números que ya no desea recibir.',
	help_ban_title: '<b> Acciones en caso de Bloqueo/Baneo </b>',
	help_ban_intro_1:
		'En caso de bloqueo/baneo, es importante seguir las acciones de recuperación y evitar nuevos bloqueos/baneos.',
	help_ban_intro_2:
		'Para recuperar un número bloqueado/prohibido, contacta a WhatsApp (Meta) para solicitar el desbloqueo a través de los siguientes canales de contacto:',
	help_link: 'Enlace de contacto',
	help_email: '- E-mails: {email1}, {email2}',
	help_ban_intro_3: '<b> Solicitud a través del enlace: </b>',
	help_ban_item_1: '1. {link} para enviar la solicitud al equipo de WhatsApp.',
	help_ban_link: 'Ingresa a este enlace',
	help_ban_item_2:
		'2. Ingrese el número de teléfono prohibido, agregue una dirección de correo electrónico para la respuesta y seleccione la opción "Web y computadora".',
	help_ban_item_3: '3. En el mensaje de solicitud puede utilizar la siguiente plantilla:',
	help_ban_item_3_1:
		"“Our company's number has been banned from WhatsApp and we don't understand why.We evaluated the messages sent and were unable to understand what led to the ban.How can we retrieve our number and normalize our customer service? Thanks!",
	help_ban_item_3_2: 'Att YOUR_COMPANY_NAME, Brasil.”',
	help_ban_item_3_3: '<b> *NOTA: Reemplace SU NOMBRE_EMPRESA con el nombre de su empresa. </b>',
	help_ban_item_4:
		'4. Cuando hagas clic en Siguiente, en la página siguiente harás clic en el botón "Enviar pregunta".',
	help_ban_item_4_1:
		'Listo, luego de enviar la solicitud, WhatsApp acusa recibo vía correo electrónico de inmediato, desbloqueándola inmediatamente o dentro de los 3 días hábiles. La respuesta de WhatsApp llegará al correo electrónico registrado.',
	help_ban_item_4_2: '<b> Solicitud por correo electrónico: </b>',
	help_ban_item_4_3:
		'1. Envíe un correo electrónico a { email1 }.Si no hay respuesta después de 72 horas, envíela a { email2 }.',
	help_ban_item_4_4:
		'2. En el título del correo electrónico, utiliza algo como "Pregunta sobre WhatsApp" o "Pregunta sobre baneos". En el cuerpo del correo electrónico, utilice la siguiente plantilla:',
	help_ban_item_4_5:
		'“El número de nuestra empresa (+55 xx xxxxxxxxx) fue baneado de WhatsApp y no entendemos por qué. Evaluamos los mensajes enviados y no pudimos entender qué llevó a la prohibición. ¿Cómo podemos recuperar nuestro número y normalizar nuestro servicio? ¡Gracias! Att NAME_DA_YOUR_COMPANY, Brasil”.',
	help_ban_conn:
		'Para conectar un nuevo número a PowerZap, preste atención a los siguientes puntos:',
	help_ban_conn_1: '1. Evite vincular el nuevo número al mismo CPF/CNPJ.',
	help_ban_conn_2:
		'2. Utilizar el número anterior en el dispositivo y WhatsApp Web para enviar y recibir mensajes y "calentar" el número.',
	help_ban_conn_3: '3. Evite usar el mismo dispositivo.',
	help_ban_conn_4: '4. Borre la cola de números antes de conectar el dispositivo.',
	help_ban_conn_5: '5. Evite los envíos masivos inicialmente.',
	help_ban_conn_6: '6. No envíe mensajes a nadie que no haya autorizado su envío.',
	help_ban_conn_7: '7. Evite el uso de lenguaje pasivo-agresivo.',
	help_ban_info: 'Para obtener más información, haga clic aquí.',

	// Help Widget
	help_widget: 'Aparatos',
	help_widget_title: '<b>Creación de Widgets</b>',
	help_widget_intro:
		'¡Capture instantáneamente los datos de contacto de los visitantes de su sitio web! Con el botón PowerZap WhatsApp, abres las puertas para atraer visitantes interesados ​​directamente en tus ofertas. ¿Y la mejor parte? ¡La instalación se simplifica y solo toma 2 minutos!',
	help_widget_1: 'Vaya al sitio web {link} y haga clic en el botón "Crea el tuyo ahora".',
	help_widget_2:
		'Rellena el formulario para personalizar tu widget e indica el número de WhatsApp que deseas asociar con él. Luego haga clic en el botón "Crear WhatsApp".',
	help_widget_3:
		'¡Listo, tu botón de WhatsApp ha sido creado! Ahora simplemente haga clic en el botón "Copiar el código" y pegue el código generado en su sitio web Bitrix24, Wordpress o cualquier otra plataforma de su elección.',
	help_widget_4: '<b>Tutorial sobre cómo integrar el widget en una página de WordPress:</b>',
	help_widget_5: '<b>Tutorial sobre cómo integrar el widget en un sitio web Bitrix24: </b>',
	help_widget_6: '<b>Tutorial sobre cómo integrar el widget en una página ReactJS: </b>',
	help_alert_video: 'Desafortunadamente, su navegador no admite la reproducción de video.',
	help_widget_btn: 'CREAR WIDGET',

	// Help campaign
	help_campaign_title: 'Campaña de marketing',
	help_campaign_1:
		'Puedes usar el servicio de campaña de marketing de Bitrix24 para enviar mensajes de WhatsApp a su base de clientes a través de la aplicación PowerZap.',
	help_campaign_2:
		'Para realizar este tipo de envíos debes acceder a la sección "Marketing" de tu Bitrix24, ir a la pestaña "Campaña" y elegir "CREAR CAMPAÑA", seleccionando la opción "Campaña SMS".',
	help_campaign_3:
		'Seleccione un filtro para el segmento al que desea enviar la campaña y cree un segmento de destinatarios.',
	help_campaign_4:
		'Los números registrados en la aplicación PowerZap aparecerán como opciones en el campo "Enviar:". Elige el número desde el que deseas enviar la campaña, edita tu mensaje de texto y guárdalo. Luego puede enviar la campaña tan pronto como Bitrix termine de preparar su segmento.',
	help_campaign_5:
		'En el siguiente video puedes ver los pasos para crear una campaña de marketing por SMS en Bitrix24:',
	help_campaign_6:
		'<b>¡Debes tener en cuenta algunos detalles importantes con respecto a este tipo de acción!</b>',
	help_campaign_7:
		'1 - El envío se produce a un destinatario aproximadamente cada minuto. Esto es necesario para que Whatsapp no ​bloquee tu cuenta. Planifique su campaña con anticipación teniendo esto en cuenta.',
	help_campaign_8:
		'2 - A pesar del tiempo entre los envíos de mensajes, la cuenta aún puede ser bloqueada si parte de los destinatarios reportan el envío como SPAM. Envía campañas a una base de clientes que quieren recibir tus comunicaciones y no te reportarán.',
	help_campaign_9:
		'3 - Las nuevas campañas creadas con el mismo número de Whatsapp solo se enviarán después de que finalice la campaña anterior. Puedes usar diferentes números para enviar campañas en el mismo período de tiempo.',
	help_campaign_10:
		'Si desea cancelar el envío de la campaña simplemente acceda a la aplicación y vaya a la pestaña "Campañas de Marketing".Esta pantalla enumerará todos los números de teléfono registrados, cuántos mensajes aún están en la cola para enviarse y la opción "Borrar cola".',
	help_campaign_11:
		'Al hacer clic en la opción "Borrar cola" deberás confirmar la acción haciendo clic en "Sí". <b> Vale la pena recordar: </b> que al elegir esta opción eliminarás todos los mensajes de campaña en la cola que estén asociados con el número de teléfono seleccionado.',
	help_campaign_12:
		'Luego, la aplicación mostrará un mensaje de éxito y los números que aún tienen mensajes de campaña en la cola para enviar.',
	// PowerZap
	number_disconnected:
		'Su número está desconectado, reinicie su sesión haciendo clic en el botón de abajo',
	number_disconnected_alert: 'Número desconectado: Escanee el código QR de ',
	disconnect: 'Desconectar',
	connected_number: 'Número conectado:',
	starting_container:
		'Su sesión está comenzando, este procedimiento puede demorar alrededor de 5 minutos. Tómate este tiempo para hidratarte, te avisaremos cuando tu código QR esté disponible.',
	session_start_alert: "'¡Su sesión de PowerZap ha comenzado, lea el QR Code!",
	reading_qrcode_message:
		'Después de leer el QR Code, espere a que se cargue la información de su sesión.',
	qrcode_polling_failed: 'No fue posible actualizar el QR Code',
	qrcode_polling_failed_message:
		'Tuvimos un problema para generar un nuevo QR Code. Intente nuevamente o use el método alternativo de conexión abajo.',
	zapi_alternative_method_cta: '¿Problemas para conectar? Use el método alternativo',
	zapi_alternative_method_error:
		'No fue posible abrir el método alternativo de conexión. Intente nuevamente en instantes.',
	zapi_alternative_method_not_ready:
		'Su conexión aún se está preparando. Espere unos instantes e intente nuevamente.',
	zapi_alternative_method_connected:
		'¡Conectado con éxito! Espere unos instantes para la confirmación final.',
	zapi_alternative_method_cancelled:
		'Método alternativo cerrado sin completar la conexión. Puede intentarlo nuevamente cuando quiera.',
	zapi_alternative_method_sdk_error:
		'Ocurrió un error durante la conexión por el método alternativo. Puede intentarlo nuevamente.',
	zapi_alternative_method_expired:
		'Su instancia ha expirado. Comuníquese con el soporte para renovarla.',
	start_session_failed: 'Error al iniciar sesión',
	register_on_chat_switch: 'Enviar mensaje al Chat de Bitrix24',
	register_on_chat_switch_alert:
		'<strong>Iniciar conversaciones desde esta funcionalidad puede causar problemas con los bots.</strong>',
	register_on_chat_switch_disabled:
		'Debe tener una conversación iniciada para habilitar esta función.',
	register_on_chat_fail: 'Error al enviar el mensaje al chat de Bitrix24',
	retry_send_message_without_register: 'Enviando mensaje al integrador fuera del chat...',
	error_empty_channel_id: 'No se puede encontrar el canal abierto para el número seleccionado',
	error_empty_dialog_id: 'No se puede encontrar un chat para entidad y número',
	confirm_set_number_on_pattern:
		'Hemos identificado que un número de destino está fuera del nuevo estándar de Brasil, que incluye el noveno dígito. ¿Quieres cambiarlo automáticamente y continuar?',

	// Help arquivos suportados
	supported_files_title: 'Envío de archivos',
	help_maximum_file_size_1:
		'La aplicación PowerZap es una plataforma que te permite enviar y recibir mensajes de manera eficiente y confiable. Sin embargo, es importante resaltar que la APP tiene un <b>límite de carga de archivos de hasta 100 MB por transferencia</b>. Esta política de límite de tamaño tiene como objetivo garantizar la estabilidad y la velocidad del servicio, brindando a los usuarios la mejor experiencia posible al compartir documentos, fotos, videos y otros tipos de archivos.',
	help_maximum_file_size_2:
		'Si necesita enviar archivos más grandes, le recomendamos dividir el contenido en partes más pequeñas o explorar otras opciones para compartir para garantizar la entrega exitosa del material.',
	help_maximum_file_size_3: '<b>Es importante prestar atención a las advertencias:</b>',
	help_maximum_file_size_4:
		'Advertencia que se muestra al intentar enviar un archivo de más de 100 MB a través de una tarjeta.',
	help_maximum_file_size_5:
		'Advertencia que se muestra al intentar enviar un archivo de más de 100 MB a través del chat de Bitrix24.',
	help_maximum_file_size_6:
		'Advertencia que se muestra al intentar enviar un archivo de más de 100 MB a través de la automatización.',

	// Br24 API (zapi)
	radio_zapi: 'Integrador de aplicaciones predeterminado',
	zapi_description_1: 'Escanee el código QR para conectar su número de WhatsApp a la aplicación.',
	zapi_description_2:
		'Para conectarte necesitas abrir la aplicación WhatsApp en tu dispositivo, en la esquina superior izquierda haz clic en los tres puntos y accede a "Dispositivos conectados".',
	meta_description:
		'Para la conexión mediante la API Oficial, accede a la <link>Guía Completa</link>.',

	// Installation Errors and Messages
	handler_bizproc_activity: 'Error al registrar la actividad del flujo de automatización',
	handler_bizproc_robot: 'Error al registrar la automatización',
	register_event: 'Error al registrar el evento',
	register_placement: 'Error al registrar la ubicación',
	handler_imconnector_message: `El Contact Center Connector es la conexión entre la aplicación API de integración de WhatsApp y las conversaciones de Bitrix24.
		Recomendado pedirle al administrador que reinstale la aplicación y si el problema persiste contactar a soporte.`,
	handler_bizproc_activity_message:
		'Este error puede impedir la creación de la opción para usar la aplicación en su flujo de automatización. Esto puede ocurrir si su plan de Bitrix24 no incluye el uso de automatizaciones.',
	handler_bizproc_robot_message:
		'Este error puede impedir el uso de automatizaciones para enviar mensajes de WhatsApp. Este error puede ocurrir si su plan de Bitrix24 no admite el uso de automatizaciones.',
	register_event_message:
		'Este error impide que la aplicación reciba un evento que ocurre en el Bitrix24.',
	register_placement_message:
		'Este error impide que la aplicación se registre en una pestaña de su Bitrix24, por lo que es imposible usarla en la pestaña dada.',
	installation_errors_found: 'Tu instalación falló, obtén más información:',
	error_found: 'Error encontrado',

	amount_of_numbers_pro: 'Números usados: PowerZap {active_pro}/{total_pro}',
	amount_of_numbers_basic: 'Números usados: BÁSICO {active_basic}/{total_basic}',
	campaign_title: 'Lista de números asociados a campañas de marketing',
	pro_numbers_title: 'Lista de números de PowerZap',
	basic_numbers_title: 'Lista de números básicos',
	add_pro_numbers_title: 'Añadir nuevo número de PowerZap',
	create_pro_trial: 'Probar número de powerzap',
	add_basic_numbers_title: 'Agregar nuevo número básico',
	api_connected: 'Estado',
	subscription: 'Suscripción',
	plan_limit: 'Has alcanzado el límite de tu plan',

	// PricingCard Component
	billing_cycle: 'mes',
	basic_tag_label: '',
	basic_description: 'Solo conector API Oficial.',
	basic_feature_1: 'Conector API Oficial',
	basic_feature_2: 'Número aprobado por Facebook',
	basic_feature_3: 'Mensajes ilimitados',
	basic_feature_4: 'Historial de conversaciones en CRM',
	basic_feature_5: 'Múltiples agentes por número de WhatsApp (opcional)',
	basic_button_label: 'Obtener Basic',
	pro_tag_label: 'Recomendado',
	pro_description: 'Paquete completo de conector/integrador PowerZap.',
	pro_feature_1: 'Conector + Integrador PowerZap',
	pro_feature_2: 'Sin necesidad de plantillas',
	pro_feature_3: 'Envío y recepción de audios',
	pro_feature_4: 'Historial de conversaciones en CRM',
	pro_feature_5: 'Simplicidad para configurar nuevos números',
	pro_button_label: 'Obtener Pro',

	// CurrentPlan Component
	current_plan_title: 'Plan actual',
	current_plan_name: 'Basic',
	current_plan_billing_cycle: 'Precio',
	current_plan_next_invoice: 'Próxima factura',
	current_plan_features: 'Características del Plan Basic',
	current_plan_feature1: 'Integrador de uTalk*',
	current_plan_feature2: 'Integrador de MessageBird',
	current_plan_feature3: '20/mes mensajes intercambiados',
	current_plan_utalk_deprecated: '* La integración se suspenderá pronto',

	// CustomizingPlan Component
	customize_plan_pro_title: 'Plan Pro | Personaliza tu plan',
	customize_plan_pro_description: 'Ya incluye un PowerZap y un número de API oficial.',
	customizing_plan_billing_period: 'Periodo de pago',
	customizing_plan_pay_month: 'Mensual',
	customizing_plan_pay_year: 'Anualmente',
	customizing_plan_months_free: '~ 2 meses gratis',
	customizing_plan_additional_numbers: 'Números adicionales',
	customizing_plan_total: 'Total',
	customizing_plan_cancel_button: 'Cancelar',
	customizing_plan_confirm_button: 'Confirmar',
	api_official: 'API Oficial',
	success_title: 'Su plan ha sido actualizado a {planName} con éxito',
	success_subtitle: 'La próxima factura se enviará en el próximo ciclo de facturación.',
	error_400: 'No se puede actualizar una suscripción con el plan ANUAL',
	error_500: 'No se puede actualizar su suscripción',
	error_subtitle: 'Póngase en contacto con el soporte.',
	go_to_dashboard_button: 'Ir al panel de control',

	PAID: 'SUSCRITO',
	PENDING: 'VENCIDA',
	TRIAL: 'TRIAL',
	CANCELED: 'CANCELADO',
	CANCELLATION_PROCESS: 'CANCELANDO',

	// numberitem Component
	validity_trial: 'Su prueba de integrador caducará en {validity}.',

	// marketing view

	change_value:
		'⚠️ Aviso importante - A partir del 1 de agosto habrá un cambio en el precio de nuestros servicios!',
	promotional_value: 'Valor promocional hasta el 31 de julio. Disfruta!',
	marketing_form_title: 'Quieres ser uno de los primeros en saber más sobre esta novedad?',
	confirmation_title: '¡Interés registrado!',
	confirmation_subtitle: 'Nos pondremos en contacto contigo pronto con más información.',

	marketing_cta_title: '¡Campañas de Marketing por WhatsApp!',
	topic1: 'Segmenta tus campañas para alcanzar exactamente a quien deseas.',
	topic2: 'Envía tus mensajes en el momento más conveniente para tus clientes.',
	topic3: 'Envía campañas con archivos de medios para un impacto visual más fuerte y eficaz.',
	topic4: 'Rastrea los resultados y la eficiencia de tus campañas para mejorarlas continuamente.',
	button_form: 'Registrar interés',

	Form_input_1: '¿Cuál es el principal objetivo del uso de las campañas por WhatsApp?',
	Form_input_1_opcion: 'Seleccione una opción',
	Form_input_1_opcion_1: 'Aumentar el compromiso de los clientes',
	Form_input_1_opcion_2: 'Promover nuevos productos o servicios',
	Form_input_1_opcion_3: 'Informar sobre promociones y descuentos',
	Form_input_1_opcion_4: 'Mejorar la comunicación y relación con los clientes',
	Form_input_1_opcion_5: 'Obtener retroalimentación de los clientes',
	Form_input_1_opcion_6: 'Otros',
	Form_input_2: 'Por favor, especifique:',
	Form_input_3: '¿Ya utiliza campañas por WhatsApp?',

	// permission view
	permission_title: 'Grupos de permisos',
	new_group: 'Nuevo',
	group_name: 'Nombre Del Grupo',
	numbers: 'Números',
	users: 'Usuarios',
	group_actions: 'Comportamiento',
	create_group_success: '¡El grupo de permisos ha sido creado!',
	create_group_error: 'No se puede crear un grupo de permisos',
	create_new_permission_group: 'Criar nuevo grupo de permisos',
	edit_new_permission_group: 'Editar nuevo grupo de permisos',
	i_permission_group_name: 'Nombre del grupo de permisos',
	whatsapp_numbers: 'Número do WhatsApp',
	placeholder_group_name: 'Dígito o nombre del grupo',
	i_whatsapp: 'Número de WhatsApp conectado',
	placeholder_whats_app: 'Haz clic aquí y selecciona el número',
	i_users: 'Usuarios de su portal',
	placeholder_users: 'Haga clic aquí y seleccione o use',
	permission_deleted_notification: '¿Está seguro de que desea eliminar este grupo de permisos?',
	btn_delete_ok: 'Sí, quiero eliminar',
	btn_delete_cancel: 'Cancelar',
	delete_group_success: '¡Grupo de permisos eliminado correctamente!',
	delete_group_error: 'No se puede eliminar el grupo de permisos',
	edited_group_success: '¡Grupo de permisos editado correctamente!',
	edited_group_error: 'No se puede editar el grupo de permisos',
	user_not_found: 'No se encontraron usuarios',
	permissions: 'Permisos',
	permissions_introduction:
		'La pestaña "Permisos" es el lugar central para administrar el acceso de los usuarios a cada número conectado a su cuenta. Aquí encontrará las siguientes características:',
	permissions_introduction_1:
		'<b>Lista de grupos:</b> Ver la lista de grupos de permisos ya creados;',
	permissions_introduction_2:
		'<b>Crear nuevo grupo:</b> cree fácilmente un nuevo grupo de permisos para personalizar el acceso;',
	permissions_introduction_3:
		'<b>Editar grupos existentes:</b> realizar ajustes a los grupos de permisos según sea necesario;',
	permissions_introduction_4: '<b>Eliminar grupos:</b> eliminar grupos que ya no son necesarios;',
	permissions_introduction_5:
		'Sólo los usuarios con privilegios de administrador tienen acceso a esta funcionalidad.',
	permissions_introduction_6: '<b>Beneficios de los grupos de permisos:</b>',
	permissions_introduction_7:
		'Una vez que se crea un grupo de permisos, solo los usuarios agregados a él tendrán acceso a las siguientes áreas y funcionalidades:',
	permissions_introduction_8: 'Panel de control;',
	permissions_introduction_9: 'Editar número;',
	permissions_introduction_10: 'Envío de mensajes a través de Card CRM;',
	permissions_introduction_11:
		'Esta función permite un control más preciso sobre quién puede interactuar con números conectados y realizar acciones específicas.',
	permissions_tutorial:
		'En la pantalla "Permisos", tendrás acceso a los grupos de permisos relacionados con cada número registrado en PowerZap.',
	permissions_tutorial_1:
		'<b>Grupo predeterminado:</b> El grupo "predeterminado" se crea automáticamente e incluye la lista de números conectados y todos los usuarios de su portal Bitrix24:',
	permissions_tutorial_2: '<b>Creando un nuevo grupo:</b>',
	permissions_tutorial_3:
		'En la pantalla principal, haga clic en "Nuevo grupo" para crear un nuevo grupo de permisos:',
	permissions_tutorial_4:
		'Al hacer clic en el botón "Nuevo grupo", será redirigido a la pantalla para crear un nuevo grupo:',
	permissions_tutorial_5: 'Rellena el formulario con los siguientes campos:',
	permissions_tutorial_6:
		'<b>Nombre del grupo:</b> Introduzca el nombre del grupo que desea crear:',
	permissions_tutorial_7:
		'<b>Número de WhatsApp:</b> Seleccione el número conectado que desea asociar con el nuevo grupo:',
	permissions_tutorial_8:
		'<b>Usuarios:</b> Selecciona los usuarios que formarán parte de este grupo:',
	permissions_tutorial_9:
		'Puede elegir la opción "Todos" para agregar todos los usuarios de su portal a este nuevo grupo o seleccionar usuarios individualmente:',
	permissions_tutorial_10:
		'Para facilitar la selección del usuario, utilice la función de búsqueda. Ingrese el nombre de usuario y aparecerá en la lista para su selección:',
	permissions_tutorial_11:
		'Después de completar los campos, haga clic en "Guardar" para crear el nuevo grupo:',
	permissions_tutorial_12:
		'Si lo desea, haga clic en "Volver" para regresar a la pantalla principal de la pestaña "Permisos":',
	permissions_tutorial_13: '<b>Edición de un grupo de permisos:</b>',
	permissions_tutorial_14:
		'Puede editar la información de un grupo de permisos existente. Para hacer esto, haga clic en el botón "Editar" en la columna de acciones del grupo que desea editar:',
	permissions_tutorial_15:
		'Serás redirigido a la página de edición, donde encontrarás un formulario completado con los datos del grupo que deseas editar:',
	permissions_tutorial_16:
		'Edite el nombre del grupo, el número de WhatsApp y los usuarios según sea necesario:',
	permissions_tutorial_17: 'Haga clic en "Guardar" para confirmar los cambios:',
	permissions_tutorial_18:
		'Si lo prefieres, haz clic en "Volver" para volver a la pantalla principal de la pestaña "Permisos":',
	permissions_tutorial_19: '<b>Eliminar un grupo de permisos:</b>',
	permissions_tutorial_20:
		'También puede eliminar un grupo de permisos existente. Para hacer esto, haga clic en el botón "Eliminar" en la columna de acciones del grupo que desea eliminar:',
	permissions_tutorial_21:
		'Después de hacer clic en "Eliminar", se mostrará una confirmación en la pantalla para garantizar que desea eliminar el grupo:',
	permissions_tutorial_22:
		'Si desea cancelar la eliminación, haga clic en "Cancelar" y el grupo no se eliminará:',
	permissions_tutorial_23:
		'Si está seguro de que desea eliminar el grupo, haga clic en "Sí, quiero eliminar" y el grupo se eliminará correctamente:',
	permissions_tutorial_24:
		'Esperamos que la guía facilite la gestión de grupos de permisos. Si tiene alguna pregunta adicional, comuníquese con nuestro soporte.',
	permissions_alert: '¡Aprenda a crear grupos de permisos en PowerZap! {link}',
	notifiable_users_alert:
		'¡Ahora puedes establecer usuarios que deben recibir notificaciones importantes sobre la aplicación! {link}',
	click_here: 'Haz clic aquí.',
	notify_click_here: 'Haz clic aquí para configurar',
	notifiable_save_success: 'Usuarios a notificar guardados con éxito',
	notifiable_save_error: 'Hubo un error al guardar la configuración',
	notifiable_tooltip:
		'Define los usuarios que recibirán notificaciones importantes sobre la aplicación.',
	notifications: 'Notificaciones',
	notified_users: 'Usuarios Notificados',
	notifiable_widget_alert: 'NUEVO 🎉🎉 Crea Widgets de WhatsApp de forma simplificada. {link}',
	notify_click_here_widget: 'Haga clic aquí para obtener más información.',
	sendings_by_type: 'Envíos por tipo',
	total_messages: 'Total:',
	received: 'Recibidos',
	crm: 'CRM',
	automacao: 'Automatización',
	campanha: 'Campañas',
	chat: 'Chat',
	percentage_evolution_tooltip: 'Evolución respecto a la media diaria del mes anterior',
	percentage_total_tooltip: 'Proporción del total de mensajes intercambiados',
	percentage_sent_tooltip: 'Proporción de envíos totales',
	select_month: 'Seleccionar mes',
	insights: 'INSIGHTS',
	insights_unavailable: 'Esta función no está disponible para el dominio actual',
	chart_messages_total_title: 'Mensajes Totales',
	chart_sent_and_received_title: 'Mensajes Enviados y Recibidos',
	chart_sending_types_title: 'Automatizaciónes, Campañas y Audios',
	chart_messages_total: 'Mensajes totales',
	chart_messages_sent: 'Enviados',
	chart_messages_received: 'Recibidos',
	chart_automation: 'Automatizaciones',
	chart_campaign: 'Campaña',
	chart_audio: 'Audio',
	insight_form_error_title: 'Se produjo un error al enviar el formulario.',
	insight_form_error_subtitle: 'Por favor, recargue la página e inténtelo de nuevo.',
	insight_form_error_message: 'Si el problema persiste, póngase en contacto con nuestro soporte.',
	insight_form_already_submitted_title:
		'Tu interés en la funcionalidad de Insights ya ha sido registrado.',
	insight_form_already_submitted_subtitle:
		'Tan pronto como esté disponible, serás uno de los primeros en probarla.',
	insight_form_success_title: '¡Listo!',
	insight_form_success_subtitle: 'Su interés ha sido transmitido a nuestro equipo.',
	insight_form_success_message: 'Nos pondremos en contacto con usted pronto.',
	insight_form_title: '¿Le gustaría ver su Panel de control?',
	insight_form_subtitle: 'Complete el formulario para solicitar información.',
	insight_form_message: 'Prometemos no utilizar su información de contacto para enviar spam.',
	insight_form_name: 'Nombre*',
	insight_form_email: 'Correo electrónico*',
	insight_form_whatsapp: 'WhatsApp',
	insight_form_send: 'Enviar',
	insight_form_required_field: 'Este campo es obligatorio',
	widget_feature: 'Generador de botones de WhatsApp',
	widget_feature_description:
		'Crea botones personalizados para agregar a tu sitio web y capturar leads automáticamente. {link}',
	widget_create_button: 'Crear Widget para Sitios Web',
	widget_table_title: 'Interacciones con el widget',
	widget_table_title_tooltip:
		'Datos recopilados de las interacciones con Widgets de números conectados a tu PowerZap.',
	widget_url: 'Sitio del Widget',
	widget_url_tooltip: 'URL del sitio donde se agregó el widget.',
	widget_number: 'Número',
	widget_redirects: 'Redirecciones',
	widget_redirects_tooltip:
		'Cantidad de veces que un cliente hizo clic en el widget y fue redirigido a tu número de WhatsApp.',
	widget_table_download: 'Descargar Datos',
	chart_widget_title: 'Interacciones Con Widgets Por Mes',
	chart_clicks: 'Clics',
	chart_redirects: 'Redirecciones',
	create_widget_button: 'Crear Widget',
	create_widget_button_tooltip:
		'Cree un botón para agregar a su sitio web y permitir que los visitantes se comuniquen con usted a través de WhatsApp.',
	objective_with_the_application: 'Objetivo principal con la aplicación',
	select_objective: 'Selecciona',
	option_increase: 'Aumentar las ventas',
	option_improve: 'Incrementar la eficiencia del servicio al cliente',
	option_automate: 'Automatizar las comunicaciones',
	option_whatsapp: 'Realizar campañas de marketing vía WhatsApp',
	option_extract: 'Extraiga información de las interacciones con clientes y prospectos',
	option_centralize: 'Centraliza las comunicaciones en una única plataforma',
	option_other: 'Otro',
	input_name: 'Escriba su nombre',
	input_email: 'Escribe tu correo electrónico',
	input_website: 'Introduzca la dirección de su sitio web',
	input_phone_label: 'Teléfono',
	input_phone: 'Ingrese su número telefónico',
	virtual_number_title: 'Agregar número virtualizado',
	virtual_number_tooltip:
		'Con el número virtualizado, no es necesario utilizar smartphones ni emuladores para cada número. La conexión es completamente virtual.',
	virtual_number_form: '¿Interesado en agregar un número virtualizado (sin teléfono inteligente)?',
	virtual_number_form_subtitle:
		'Complete el siguiente formulario y nuestro equipo le brindará más detalles sobre cómo funciona.',
	virtual_number_input_1: 'Nombre',
	virtual_number_input_1_placeholder: 'Escriba su nombre',
	virtual_number_input_2: 'Correo electrónico',
	virtual_number_input_2_placeholder: 'Escribe tu correo electrónico',
	virtual_number_input_3: 'WhatsApp',
	virtual_number_input_3_placeholder: 'Introduce tu número de WhatsApp',
	virtual_number_input_4: 'Cantidad de números virtualizados',
	virtual_number_input_4_placeholder: 'Seleccione la cantidad de números virtualizados',
	virtual_number_send: 'Enviar',
	virtual_number_option_1: '1 número',
	virtual_number_option_2: '2 números',
	virtual_number_option_3: '3 números',
	virtual_number_option_4: '4 números',
	virtual_number_request: 'Introduce el número virtual ',
	virtual_number_error_1: 'Hubo un error al enviar el formulario',
	virtual_number_error_2:
		'Por favor, recarga la página y vuelve a intentarlo. Si el problema persiste, contacta con nuestro soporte.',
	virtual_number_success_1: '¡Hecho!',
	virtual_number_success_2:
		'Su interés se ha transmitido a nuestro equipo. Pronto nos pondremos en contacto contigo.',
	btn_loading_trial: 'Enviando datos, por favor espere...',
	virtual_number_name_error_1: 'Por favor, escriba su nombre',
	virtual_number_name_error_2: 'El nombre debe contener solo letras.',
	virtual_number_email_error_1: 'Por favor, introduzca su correo electrónico',
	virtual_number_email_error_2: 'Por favor, introduzca una dirección de correo electrónico válida',
	virtual_number_whats_error_1: 'Por favor, ingresa tu WhatsApp',
	virtual_number_whats_error_2: 'WhatsApp solo debe contener números',
	virtual_number_quantity_error: 'Por favor, seleccione la cantidad de números virtualizados',
	virtual_number_virtualized_error:
		'Por favor, ingresa el número de WhatsApp para ser virtualizado',
	form_trial_website_error: 'Por favor, ingrese al sitio web de la empresa',
	form_trial_country_error: 'Por favor, seleccione su país',
	form_trial_phone_error_1: 'Por favor, introduzca su número de teléfono',
	form_trial_phone_error_2: 'El teléfono debe contener solo números.',
	form_trial_objective_error: 'Por favor, seleccione el objetivo principal con la aplicación.',
	help_360_dialog_1: '360dialog (API Oficial)',
	help_360_dialog_2: 'Cómo conectar su cuenta de 360 ​​Dialog a Bitrix24',
	help_360_dialog_3:
		'Para configurar nuestro conector con 360dialog, puedes comenzar desde el propio PowerZap. Mira el siguiente video sobre cómo configurar la integración y enviar tus primeros mensajes a través de Bitrix24:',
	help_360_dialog_4: 'Su navegador no soporta la etiqueta de vídeo.',
	help_360_dialog_5:
		'¿Ya tienes una cuenta de 360 ​​Dialog y te gustaría solicitar un cambio de socio?',
	help_360_dialog_6: 'Siga esta guía para cambiar de socio',
	help_360_dialog_7: ' y, si es necesario, informar el ID del socio Br24: {partner}.',
	help_360_dialog_8: 'Tutorial detallado',
	help_360_dialog_9: 'Cómo conectar un número de WhatsApp 360dialog a Bitrix24:',
	help_360_dialog_10:
		'Para conectar un nuevo número, simplemente haga clic en "Agregar nuevo número" en la sección Números básicos',
	help_360_dialog_11:
		'Una vez que se abra la ventana emergente, seleccione la opción API "360dialog" y haga clic en "Agregar nuevo número".',
	help_360_dialog_12:
		'Después de esto, notarás que se abrirá una nueva ventana superpuesta a PowerZap. Allí creará su cuenta de 360 ​​Dialog completando los campos del formulario o, si ya tiene una cuenta de 360 ​​Dialog, simplemente inicie sesión haciendo clic en "Iniciar sesión" en la parte superior de la ventana.',
	help_360_dialog_13:
		'Si ya tienes una cuenta 360dialog contratada directamente con ellos, puedes solicitar al soporte de 360 ​​Dialog que cambie tu plan, indicando el contrato a través del socio 360dialog (PowerZap - Br24), recibiendo así un descuento en el precio del plan.',
	help_360_dialog_14: 'Para obtener más información sobre los precios practicados por 360dialog',
	help_360_dialog_15: ' accede a este enlace.',
	help_360_dialog_16:
		'Nota: utilizando Chrome como navegador, puede traducir los pasos haciendo clic derecho y seleccionando la opción de traducción al portugués. A partir de ahora mostraremos las páginas traducidas en portugués.',
	help_360_dialog_17:
		'En el siguiente paso, deberás ingresar el estado actual del número de WhatsApp que deseas agregar.',
	help_360_dialog_18: 'Si su número está conectado a la API de WhatsApp Business',
	help_360_dialog_19:
		'Luego de seleccionar la opción y hacer clic en “Confirmar detalles del número”, proceda ingresando el número de teléfono que desea agregar y valide la información necesaria para poder continuar.',
	help_360_dialog_20:
		'En el siguiente paso, deberá completar el Meta registro integrado, simplemente siga las instrucciones paso a paso.',
	help_360_dialog_21:
		'Luego de completar el registro incorporado, verás una ventana con el logo de Facebook, donde deberás continuar',
	help_360_dialog_22:
		'Luego de seguir el paso anterior, completa la información solicitada y sigue los siguientes 4 pasos.',
	help_360_dialog_23:
		'Nota: Si el número a vincular está vinculado a otro integrador (ej.: Twilio), primero será necesario desvincularlo de este integrador y luego proceder al siguiente paso.',
	help_360_dialog_24:
		'Ahora solo continúa con la autorización de la solicitud de socio, donde el socio es Br24.',
	help_360_dialog_25:
		'Después de la autorización de la solicitud de socio, espere unos segundos. En este punto, se enviará una comunicación a la aplicación, que a su vez agregará el nuevo número a su portal.',
	help_360_dialog_26:
		'Una vez que aparezca el mensaje de éxito, simplemente cierre la ventana y vuelva a cargar la página de PowerZap.',
	help_360_dialog_27:
		'⚠️ Para enviar sus mensajes a través de la Meta API oficial a través de PowerZap, primero debe validar estos mensajes en 360dialog. Estos mensajes validados se denominan "plantillas". Para hacer esto, simplemente inicie sesión en 360dialog y siga las ',
	help_360_dialog_28: 'Validación del modelo paso a paso.',
	help_360_dialog_29:
		'Si su número NO está conectado a la API de WhatsApp Business pero está conectado a una cuenta personal',
	help_360_dialog_30:
		'Si su número está conectado a una cuenta personal de WhatsApp, deberá desconectar su número de su cuenta personal para migrar a una cuenta API de WhatsApp Business. Para hacer esto, simplemente haga clic ',
	help_360_dialog_31: '"Cómo desconectar un número de una cuenta personal de WhatsApp” ',
	help_360_dialog_32: 'y sigue las instrucciones paso a paso.',
	help_360_dialog_33:
		'Luego de eso, deberás regresar a este paso y seleccionar la opción “No, este número no está conectado a una cuenta personal de WhatsApp”.',
	help_360_dialog_34:
		'Si su número NO está conectado a la API de WhatsApp Business ni a una cuenta personal',
	help_360_dialog_35: 'Si su número no cumple con ninguna de las dos opciones, deberá ',
	help_360_dialog_36: 'conecte su número a la API de WhatsApp Business en su cuenta Meta.',
	help_360_dialog_37:
		'Después de eso, deberá regresar a esta ventana y proceder de la siguiente manera ',
	help_360_dialog_38: 'este paso a paso.',
	help_360_dialog_39: 'Plantillas',
	help_360_dialog_40:
		'Se requiere una plantilla de mensaje para que la Compañía inicie una nueva conversación con su contacto. Esto es necesario si no ha habido interacción entre ellos previamente o si el último mensaje enviado por el usuario tiene más de 24 horas. Para más detalles, ',
	help_360_dialog_41: 'haga clic aquí.',
	help_360_dialog_42:
		'Después de la validación, las plantillas deben estar disponibles para su envío vía PowerZap (vía tarjeta y automatización).',
	help_360_dialog_43: 'Envío manual:',
	help_360_dialog_44:
		'Para configurar la automatización, debe ingresar el nombre de la plantilla seguido de “#template:”. También puedes personalizar el mensaje con la información registrada en las tarjetas. Para hacer esto, simplemente ingrese los campos a utilizar, como se muestra en el siguiente ejemplo:',
	help_360_dialog_45: '¿Tiene alguna pregunta sobre el diálogo 360?',
	help_360_dialog_46:
		'Póngase en contacto con el equipo de soporte de 360 ​​​​Diálogo a través del sitio web ',
	help_360_dialog_47: 'https://www.360dialog.com/contact ',
	help_360_dialog_48: 'o envíe un correo electrónico a support@360dialog.com',
	help_360_dialog_49: 'Ayuda de 360dialog',
	help_360_dialog_50: '¿Aún necesitas ayuda?',
	help_360_dialog_51: 'Póngase en contacto con el soporte de 360 ​​Dialog a través del sitio web ',
	help_360_dialog_52: 'Conectar el 360dialog',

	notification_checkbox: 'Recibir notificación de número inválido.',
	info_notification:
		'Al marcar esta opción, algunos usuarios recibirán notificaciones si se envía un mensaje a un número inválido a través de un número pro.',
	info_notification_2:
		'Envío por tarjeta: Recibirán la notificación el responsable de la tarjeta, la persona que envía y las personas registradas en esta lista.',
	info_notification_3:
		'Envío de automatización: Se enviará al responsable de la tarjeta y a las personas en esta lista.',
	info_notification_4:
		'Envío de campaña: Solo las personas en esta lista recibirán la notificación.',

	openai_token_required:
		'Se requiere una clave API de OpenAI para habilitar la transcripción de audio',
	openai_token_invalid:
		"Formato de clave API de OpenAI inválido. Debe comenzar con 'sk-' y tener al menos 48 caracteres",
	audio_transcription_tooltip:
		'Proporciona tu clave API de OpenAI para que PowerZap pueda transcribir automáticamente los mensajes de audio recibidos a texto.',
	new_button_placeholder: 'Nuevo botón...',
	select_options_to_continue: 'Seleccione las opciones para continuar.',
	call: 'Llamar',
	rapid_reply_title: 'Botones de respuesta rápida',
	confirm: 'Confirmar',
	no_thanks: 'No, gracias',
	i_want: 'Quiero',
	no: 'No',
	rapid_reply_tooltip: 'Seleccione o cree botones para estimular respuestas rápidas y objetivas.',
	files_with_buttons: 'Envío de archivos con botones',
	files_with_buttons_tooltip:
		'Envío de archivos con botones soporta imágenes y vídeos, otros tipos de archivos no son soportados y no funcionarán correctamente.',
	invalid_number: 'Uno de los números proporcionados es inválido.',

	help_meta_connect: 'Cómo conectar',
	help_meta_title: 'Evita que tu número sea bloqueado',
	help_meta_description:
		'Para evitar que tu número sea bloqueado por Meta durante la integración, sigue esta lista de verificación antes de continuar:',
	help_meta_item_1: 'Utiliza únicamente la API Oficial de Meta',
	help_meta_item_1_description:
		'Tu número no debe estar conectado a ninguna plataforma con API no oficial, incluido el número Pro de Powerzap.',
	help_meta_item_2: 'Verifica tu empresa en Meta',
	help_meta_item_2_description: '<link>Verificar ahora</link>',
	help_meta_item_3: 'Agrega un método de pago válido en Meta',
	help_meta_item_3_description: '<link>Agregar método de pago</link>',
	help_meta_item_4: 'Ten al menos una plantilla de mensaje aprobada',
	help_meta_item_4_description: '<link>Crear plantilla de mensaje</link>',
	help_meta_info:
		'Para más detalles, accede a la <link>Guía completa paso a paso</link> para la integración de la API Oficial de Meta en Powerzap.',
	help_meta_btn: 'Siguiente',
	help_meta_confirm_checkbox:
		'Confirmo que ya cumplí con todos los elementos anteriores y entiendo que continuar sin cumplir con la lista de verificación puede resultar en el bloqueo del número por parte de Meta.',
	msg_error_openai_token:
		'El número se guardó correctamente, pero hubo un problema al guardar la configuración de OpenAI. Inténtalo de nuevo',
};

export { language };
